/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, shape, string, bool,
} from 'prop-types';

const styles = (theme) => ({
    FrontCardSide: {
        width: '384px',
        height: '576px',
        marginLeft: '30%',
        [theme.breakpoints.down(1660)]: {
            width: '350px',
            maxHeight: 420,
            minHeight: 420,
        },
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0,
            maxHeight: 370,
            minHeight: 370,
        },
    },
    image: {
        width: '100%',
        height: '100%',
    },
    horizontalImage: {
        transform: 'rotate(90deg)',
    },
});

const ReviewFrontCard = ({ classes, cardData, isHorizontal }) => (
    <div className={classes.FrontCardSide}>
        <img src={cardData?.front_view?.card_image?.url} className={`${classes.image} ${isHorizontal ? classes.horizontalImage : ''}`} alt="template" />
    </div>
);

ReviewFrontCard.propTypes = {
    classes: object.isRequired,
    cardData: shape({
        url: string,
    }),
    isHorizontal: bool.isRequired,
};

ReviewFrontCard.defaultProps = {
    cardData: {},
};

export default withStyles(styles)(ReviewFrontCard);
